import { socket } from '../socket'

// The user's own room on the socket: what belongs to one person across their
// tabs and devices, today the read marks of comments. The room is named by the
// token on the server side, so joining is just presenting it; a guest has no
// token and no room.
export const joinUserRoom = () => {
  const token = localStorage.getItem('token')

  if (token && socket.connected) {
    socket.emit('user:join', token)
  }
}

export const leaveUserRoom = () => {
  if (socket.connected) {
    socket.emit('user:leave')
  }
}
